import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47ef1fa8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["poster", "autoplay"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'video',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["mod video", { ['video--' + __props.d.type[0]]: true, 'inner': __props.d.type[0] === 'full' }]),
                style: _normalizeStyle({ 'margin-bottom': __props.d.video_autoplay !== '1' ? '2rem' : '0' })
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass([{ 'inner': __props.d.type[0] === 'inset' }, { 'container': __props.d.type[0] === 'frame' }])
                }, [
                    _createElementVNode("video", {
                        class: _normalizeClass([{ 'container': __props.d.type[0] === 'frame' }, { 'inner': __props.d.type[0] !== 'frame' }]),
                        playsinline: "",
                        poster: __props.d.video_poster,
                        autoplay: __props.d.video_autoplay === '1'
                    }, [
                        _createElementVNode("source", {
                            src: __props.d.video_mp4,
                            type: "video/mp4"
                        }, null, 8, _hoisted_2),
                        _createElementVNode("source", {
                            src: __props.d.video_webm,
                            type: "video/webm"
                        }, null, 8, _hoisted_3)
                    ], 10, _hoisted_1)
                ], 2)
            ], 6));
        };
    }
});
